
<template>
	<div class="no-print">
		<v-app-bar color="primary">
			<template v-slot:prepend>
				<v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
			</template>
			<v-app-bar-title>
				<v-btn variant="text" to="/">
					جیهانی قایش
				</v-btn>
			</v-app-bar-title>
			<v-spacer></v-spacer>
			<v-btn variant="text" class="me-1" @click="refreshTab">
				<v-icon start>mdi-refresh</v-icon>
				نوێکردنەوە
			</v-btn>
			<v-btn icon @click="logout">
				<v-icon>mdi-logout</v-icon>
			</v-btn>
		</v-app-bar>
		<v-navigation-drawer v-model="drawer" temporary>
			
			<v-divider class="py-3"></v-divider>
             
            <p class="text-center text-rang">   کاڵاکان 
            </p>
            <v-list-item :to="'/categories-list'">
                زیادکردنی جۆر
            </v-list-item>
            <v-list-item :to="'/items-list'">
                زیادکردنی کاڵا
            </v-list-item>
            <v-list-item :to="'/items-list-qaish'">
                زیادکردنی قایش
            </v-list-item>
            <v-list-item :to="'/items-price-change-history'">
                مێژووی نرخی کاڵا
            </v-list-item>
            <v-list-item :to="'/sets-list'">
               زیادکردنی سێت
            </v-list-item>
            <v-divider class="py-5"></v-divider>
            <p class="text-center text-rang">   کۆگاکان 
            </p>
            <v-list-item :to="'/inventories-list'">
                 کۆگاکان
            </v-list-item>
            <v-list-item :to="'/inventory_items-list'">
         زیادکردنی کاڵا بۆ کۆگا
            </v-list-item>
            <v-list-item :to="'/inventory_items-list_view'">
ڕاپۆرتی عەدەدی کاڵا           </v-list-item>
    
            <v-list-item :to="'/item_moves-list'">
                 گۆڕینی شوێنی کاڵا
            </v-list-item>
                <v-list-item :to="'/inventory_items-history'">
                 مێژووی عەدەدی کاڵا           </v-list-item>
            
            <v-divider class="py-5"></v-divider>

            <p class="text-center text-rang">   فڕۆشتن
            </p>
            <v-list-item :to="'/customers-list'">           
               حسابی کڕیاران
            </v-list-item>
            <v-list-item :to="'/invoices-list'">
                زیادکردنی فڕۆشتن
            </v-list-item>
            <v-list-item :to="'/invoices-view'">
                گەڕانی وەصڵەکان
            </v-list-item>
            
            <v-divider class="py-5"></v-divider>
            <p class="text-center text-rang">   دابینکەران
            </p>
            <v-list-item :to="'/suppliers-list'">
                دابینکەران
            </v-list-item>
            <v-list-item :to="'/supplier_invoices-list'">
                زیادکردنی وەسڵی دابینکەران
            </v-list-item>
            <v-list-item :to="'/supplier_invoices-view'">
                وەسڵی دابینکەران
            </v-list-item>
            <v-list-item :to="'/suppliers-view'">
                حسابی دابینکەران
            </v-list-item>
            <v-divider class="py-5"></v-divider>
            <p class="text-center text-rang">   خەرجییەکان
            </p>
            <v-list-item :to="'/expense_categories-list'">
                زیادکردنی جۆری خەرجی
            </v-list-item>
            <v-list-item :to="'/expenses-list'">
                زیادکردنی خەرجی
            </v-list-item>
            <v-divider class="py-5"></v-divider>
             <p class="text-center text-rang">   هەژمارەکان
            </p>
            
            <v-list-item  :to="'/bank_accounts-list'">
                لیستی
                هەژمارەکان
            
            </v-list-item>
            <v-list-item  :to="'/bank_account_transfers-list'">
                ئاڵوگۆری هەژمارەکان
            </v-list-item>
			<v-divider class="py-5"></v-divider>
            <p class="text-center text-rang">   ڕاپۆرت
            </p>
            <v-list-item :to="'/report'">
               ڕاپۆرتەکان
            </v-list-item>
            <v-list-item :to="'/invoice_items-list'">
               ڕاپۆرتی کاڵا فڕۆشراوەکان
            </v-list-item>
            <v-divider class="py-5"></v-divider>


			<!-- <v-list density="compact" nav>
				<v-list-item v-for="(item, index) in navigation_links" :key="index" :to="item.path">
					{{ item.title }}
				</v-list-item>
			</v-list> -->
		</v-navigation-drawer>
	</div>
</template>
<script setup>
	import { ref, computed } from 'vue';
	import { useStore } from 'vuex';
	const store = useStore();
	let drawer = ref(false);
	const refreshTab = () => {
		window.location.reload();
	}
	const logout = () => {
		store.dispatch('logout');
	}
	const navigation_links = computed(() => {
		const content = [

			{
				path: '/bank_account_transfers-list',
				title: 'ئاڵوگۆری هەژمارەکان  ',
			},

			{
				path: '/bank_accounts-list',
				title: 'هەژمارەکان   ',
			},

			{
				path: '/categories-list',
				title: 'جۆرەکانی کاڵا   ',
			},

			{
				path: '/customer_payments-list',
				title: 'پارەدانی کڕیار',
			},

			{
				path: '/customers-list',
				title: 'کڕیارەکان   ',
			},

			{
				path: '/expense_categories-list',
				title: 'جۆرەکانی خەرجی  ',
			},

			{
				path: '/expenses-list',
				title: 'خەرجییەکان  ',
			},

			{
				path: '/inventories-list',
				title: 'کۆگاکان  ',
			},

			{
				path: '/inventory_items-list',
				title: 'کاڵاکانی کۆگاکان   ',
			},
			{
				path: '/inventory_items-history',
				title: 'مێژووی کاڵاکانی کۆگا',
			},
			{
				path: '/inventory_items-list_view',
				title: 'گەڕانی کاڵا  ',
			},

			// {
			//     path : '/invoice_items-list',
			//     title : 'کاڵاکانی پسوڵەکان',
			// },

			{
				path: '/invoices-list',
				title: 'فڕۆشتن',
			},
			{
				path: '/invoices-view',
				title: 'گەڕانی فڕۆشتن',
			},

			{
				path: '/item_moves-list',
				title: 'گۆڕینی شوێنی کاڵا  ',
			},

			{
				path: '/item_stocks-list',
				title: 'کاڵا خەساربووەکان  ',
			},

			{
				path: '/items-list',
				title: 'کاڵاکان    ',
			},
			{
				path: '/items-price-change-history',
				title: 'مێژووی نرخی کاڵا',
			},

			// {
			//     path : '/supplier_invoice_items-list',
			//     title : 'Supplier Invoice Items',
			// },

			{
				path: '/supplier_invoices-list',
				title: ' وەسڵی دابینکەران    ',
			},

			{
				path: '/supplier_payments-list',
				title: 'پارەدانی دابینکەران',
			},

			{
				path: '/suppliers-list',
				title: 'دابینکەران   ',
			},

			{
				path: '/users-list',
				title: 'بەکارهێنەران',
			},
			{
				path: '/store_informations-list',
				title: 'Store Informations',
			},

		];
		return content;
	});

</script>
        